import React, { FC } from "react";

import { useBoolean } from "~/hooks";

import { AIAvatar, Link, ModalWrapper } from "~/components/atoms";

type PropsType = {
  message: string;
  subtitle?: string;
  link?: {
    url: string;
    text: string;
  };
  className?: string;
};

export const KagaminMessage: FC<PropsType> = ({
  message,
  subtitle = "かがみんのメッセージ",
  link,
  className = "",
}: PropsType) => {
  const {
    isChecked: isModalOpen,
    setTrue: openModal,
    setFalse: closeModal,
  } = useBoolean(false);

  return (
    <div className={`${className}`}>
      <div className="w-4/5 mx-auto flex flex-col items-center gap-4">
        <button
          className="relative w-full text-center py-3 px-4 rounded-br-xl rounded-tl-xl rounded-tr-xl border border-solid border-secondary-400 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={openModal}
          type="button"
        >
          <p className="text-xs text-secondary-600 truncate">{subtitle}</p>
          <p className="text-sm text-secondary-900 truncate mt-1">{message}</p>
        </button>

        <button onClick={openModal} className="cursor-pointer" type="button">
          <AIAvatar type="peekingPose" size="lg" className="rounded-none" />
        </button>
      </div>
      {/* 画像の下に重なる線 */}
      <hr className="w-full border-t-2 border-primary-600 -mt-5 z-lowest" />
      {isModalOpen && (
        <ModalWrapper onClose={closeModal} headerTitle="かがみんのコメント">
          <div className="mt-6 space-y-4">
            {subtitle && (
              <p className="text-secondary-700 text-sm font-bold">{subtitle}</p>
            )}

            <blockquote className="mt-2 border-l-4 border-primary-600 bg-gray-50 pl-4 pr-3 py-3">
              <p className="text-secondary-900 whitespace-pre-wrap">
                {message}
              </p>
            </blockquote>

            {link && (
              <Link
                to={link.url}
                className="text-primary-600 underline visited:text-purple-600 block"
              >
                {link.text}
              </Link>
            )}

            <div className="flex justify-center">
              <AIAvatar
                type="standing"
                size="xl"
                className="rounded-none"
                autoHeight
              />
            </div>
          </div>
        </ModalWrapper>
      )}
    </div>
  );
};
